//用户列表的功能
import request from './request'

//获取用户列表信息
export function _userList(data = {}) {
    const config = Object.assign(data, {
      method: 'get',
      url: '/admin/user/index',
    })
    return request(config)
}
//用户单个信息
export function _userSingleInfo(data = {}) {
  const config = Object.assign(data, {
    method: 'get',
    url: '/admin/user/getinfo',
  })
  return request(config)
}
//单个用户信息编辑
export function _userSingleEdit(data = {}) {
  const config = Object.assign(data, {
    method: 'post',
    url: '/admin/user/edit',
  })
  return request(config)
}

//加入黑名单
export function _addUserBlack(data = {}) {
  const config = Object.assign(data, {
    method: 'get',
    url: '/admin/user/black',
  })
  return request(config)
}

//用户信息编辑
export function _userEdit(data = {}) {
  const config = Object.assign(data, {
    method: 'post',
    url: '/admin/user/edit',
  })
  return request(config)
}

//用户的信息采集记录
export function _userRegistration(data = {}) {
  const config = Object.assign(data, {
    method: 'get',
    url: '/admin/form-registration/index',
  })
  return request(config)
}

//听课记录
export function _userHistoryListen(data = {}) {
  const config = Object.assign(data, {
    method: 'get',
    url: '/admin/history/index',
  })
  return request(config)
}


//获取社区评论列表
export function _commentList(data = {}) {
  const config = Object.assign(data, {
    method: 'get',
    url: '/admin/comment/index',
  })
  return request(config)
}

//评论回复
export function _commentReply(data = {}) {
  const config = Object.assign(data, {
    method: 'post',
    url: '/admin/comment/reply',
  })
  return request(config)
}

//社区评论删除
export function _commentRemove(data = {}) {
  const config = Object.assign(data, {
    method: 'get',
    url: '/admin/comment/remove',
  })
  return request(config)
}


//控件添加
export function _formControlAdd(data = {}) {
  const config = Object.assign(data, {
    method: 'post',
    url: 'admin/form-control/add',
  })
  return request(config)
}

//控件删除
export function _formControlRemove(data = {}) {
  const config = Object.assign(data, {
    method: 'get',
    url: 'admin/form-control/remove',
  })
  return request(config)
}

//获取控件列表
export function _formControlList(data = {}) {
  const config = Object.assign(data, {
    method: 'get',
    url: '/admin/form-control/index',
  })
  return request(config)
}

// 用户反馈
export function _userFeedbackList(data = {}) {
  const config = Object.assign(data, {
    method: 'get',
    url: '/admin/feedback/index',
  })
  return request(config)
}

//回复用户反馈信息
export function _userFeedbackInfo(data = {}) {
  const config = Object.assign(data, {
    method: 'post',
    url: '/admin/feedback/reply',
  })
  return request(config)
}
